import React, { Fragment, useEffect, useState } from "react";
import ModalContainer from "./modalcontainer";
import { IoMdClose } from "react-icons/io";
import FileInput from "../inputs/fileinput";
import ArrowDown from "../../assets/icons/arrow-down.svg";
import { MainBtn } from "../app/buttons";
import { NewInput, TextBox } from "../inputs/main";
import Extractor from "../../data/useExtractor";
import { FaTimes } from "react-icons/fa";
import { toast } from "react-toastify";
import { apiCall } from "../../data/useFetcher";
import useErrorStore from "../../data/stores/errorStore";
import { useRawdataStore } from "../../data/stores/loggerStore";
import { useLocation } from "react-router-dom";

const AddToolsModal = ({ handleClose }) => {
	return (
		<div>
			<ModalContainer handleClose={handleClose}>
				<div>
					<div className="flex justify-between">
						<div>
							<h3 className="text-xl font-bold text-black">Upload new tool</h3>
							<p className="text-sm mt-2 font-normal text-[#344054]">
								Add new tool for an excel or csv file. Download sample file
							</p>
						</div>
						<IoMdClose
							size={20}
							onClick={handleClose}
							className="cursor-pointer"
							color="#A6A6A6"
						/>
					</div>
					<div className="mt-6">
						<FileInput />
					</div>
					<div className="mt-4 flex justify-between items-center">
						<div className="flex gap-3 items-center">
							<img src={ArrowDown} alt="" className="" />
							<h6 className="text-[#3787FF] font-medium text-base">
								Download sample file
							</h6>
						</div>
						<div className="flex gap-5">
							<MainBtn
								onClick={handleClose}
								className="border border-[#3787FF]"
								text={"Cancel"}
								bg={"transparent"}
								color={"#3787FF"}
							/>
							<MainBtn
								onClick={handleClose}
								text={"Import"}
								bg={"#3787FF"}
								color={"white"}
							/>
						</div>
					</div>
				</div>
			</ModalContainer>
		</div>
	);
};

type AddNew = {
	handleClose: () => void;
	handleImport?: (pres: any) => void;
	title?: string;
	subtitle?: string;
	sample?: any;
	processInner?: any;
	loading?: boolean;
};

export const AddUsersModal = ({
	handleClose,
	title,
	subtitle,
	handleImport,
	sample,
	processInner,
	loading,
}: AddNew) => {
	let [pres, setPres] = useState([]);

	return (
		<div>
			<ModalContainer handleClose={loading ? () => {} : handleClose}>
				<div>
					<div className="flex justify-between">
						<div>
							<h3 className="text-xl font-bold text-black">
								{title || `Upload new users list`}
							</h3>
							<p className="text-sm mt-2 font-normal text-[#344054]">
								{subtitle || `Add new users`} from an excel or csv file.
								Download sample file
							</p>
						</div>
						<IoMdClose
							size={20}
							onClick={handleClose}
							className="cursor-pointer"
							color="#A6A6A6"
						/>
					</div>
					<div className="mt-6">
						{/* <FileInput /> */}
						<Extractor
							pres={pres}
							setPres={setPres}
							processInner={processInner}
						/>
					</div>
					<div className="mt-4 flex justify-between items-center">
						{sample ? (
							<>
								<a
									href={sample}
									download={sample?.name}
									target="_blank"
									rel="noreferrer"
									className="flex gap-3 items-center">
									<img src={ArrowDown} alt="" className="" />
									<h6 className="text-[#3787FF] font-medium text-base">
										Download sample file
									</h6>
								</a>
							</>
						) : (
							<div className="flex gap-3 items-center">
								<img src={ArrowDown} alt="" className="" />
								<h6 className="text-[#3787FF] font-medium text-base">
									Download sample file
								</h6>
							</div>
						)}
						<div className="flex gap-5">
							<MainBtn
								onClick={handleClose}
								className="border border-[#3787FF]"
								text={"Cancel"}
								bg={"transparent"}
								color={"#3787FF"}
								disabled={loading}
							/>
							<MainBtn
								onClick={
									handleImport
										? () => {
												handleImport(pres);
										  }
										: handleClose
								}
								text={"Import"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
							/>
						</div>
					</div>
				</div>
			</ModalContainer>
		</div>
	);
};

export const AddDataModal = ({ handleClose, title, subtitle }: AddNew) => {
	return (
		<div>
			<ModalContainer handleClose={handleClose}>
				<div>
					<div className="flex justify-between">
						<div>
							<h3 className="text-xl font-bold text-black">
								{title || `Upload new users list`}
							</h3>
							<p className="text-sm mt-2 font-normal text-[#344054]">
								{subtitle || `Add new users`}
							</p>
						</div>
						<IoMdClose
							size={20}
							onClick={handleClose}
							className="cursor-pointer"
							color="#A6A6A6"
						/>
					</div>
					<div className="py-6">
						<NewInput label={"Category"} placeholder={"Enter"} />
						<NewInput label={"Data"} placeholder={"Enter"} />
					</div>
					<div className="mt-4 flex justify-between items-center">
						<div className="flex gap-3 items-center"></div>
						<div className="flex gap-5">
							<MainBtn
								onClick={handleClose}
								className="border border-[#3787FF]"
								text={"Cancel"}
								bg={"transparent"}
								color={"#3787FF"}
							/>
							<MainBtn
								onClick={handleClose}
								text={"Create"}
								bg={"#3787FF"}
								color={"white"}
							/>
						</div>
					</div>
				</div>
			</ModalContainer>
		</div>
	);
};

export const AddDataToolModal = ({
	handleClose,
	title,
	subtitle,
	sample,
	processInner,
}: AddNew) => {
	let init2: {
		category?: string;
		data?: string;
		dataArr?: string[];
		description?: string;
	} = {};
	const [itemForm, setItemForm] = useState([init2]),
		[loading, setLoading] = useState(null),
		{ returnErrors } = useErrorStore(),
		{ getDynamicLogger, getLogger } = useRawdataStore(),
		location = useLocation()?.state;
	const handleInputChangeForMutipleItem = (
		e: React.ChangeEvent<HTMLInputElement> | any,
		index: number,
		field: string
	) => {
		const { value } = e?.target;
		let itemValue = value;

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			newRows[index][field] = itemValue;
			return newRows;
		});
	};
	const handleInputKeyPress = (
		e: React.KeyboardEvent<HTMLInputElement>,
		index: number,
		field: string
	) => {
		console.log({ e });

		setItemForm(prevRows => {
			const newRows = [...prevRows];
			// console.log({ e: e.key });
			let emailInput = newRows[index].data;
			if (e.key === "Enter" && emailInput.trim() !== "") {
				e?.preventDefault(); // This prevents the default form submission behavior
				newRows[index][field] = Array.isArray(newRows[index][field])
					? [...newRows[index][field], emailInput.trim()]
					: [emailInput.trim()];
				newRows[index].data = "";
			}
			return newRows;
		});
	};

	useEffect(() => {
		if (sample) {
			setItemForm([
				{
					category: sample?.category,
					description: sample?.description,
					data: "",
					dataArr: sample?.data?.map((it: any) => it?.title),
				},
			]);
		}
	}, [sample]);

	const onSubmit = async (event?: React.FormEvent<HTMLFormElement>) => {
		event?.preventDefault();
		if (itemForm?.length === 0) return toast.info("Data set required");
		if (itemForm?.length === 1)
			if (!itemForm?.[0]?.category || itemForm?.[0]?.dataArr?.length === 0)
				return toast.info("Data set required");

		setLoading(true);

		let { response, errArr, errMsg } = await apiCall({
			type: "put",
			url: `/api/v1/rawdata${
				processInner === "application-level" ? "/manage-kpis" : ""
			}`,
			data: {
				rawdata: itemForm?.map(item => {
					return {
						...item,
						data: item?.dataArr?.map(it => {
							return {
								title: it?.trim(),
							};
						}),
						_id: sample?._id,
						upperCategory: sample?.upperCategory,
					};
				}),
			},
		});
		// console.log({ response, errArr, errMsg });
		if (errArr) {
			setLoading(false);
			return returnErrors(errArr);
		}
		if (errMsg) {
			setLoading(false);
			return toast.error(errMsg);
		}
		setLoading(false);
		if (response) {
			if (processInner === "application-level")
				apiCall({
					type: "get",
					url: `/api/v1/rawdata/manage-kpis?category=${location?.category}&data=${location?.item?.title}`,
					getter: (d: any) => getDynamicLogger(d, "kpidata"),
				});
			else {
				apiCall({
					type: "get",
					url: `/api/v1/rawdata`,
					getter: (d: any) => getLogger(d),
				});
			}
			handleClose();
			return;
		}
		setLoading(false);
	};

	return (
		<div>
			<ModalContainer handleClose={handleClose}>
				<div>
					<div className="flex justify-between">
						<div>
							<h3 className="text-xl font-bold text-black">
								{title || `Upload new users list`}
							</h3>
							<p className="text-sm mt-2 font-normal text-[#344054]">
								{subtitle || `Add new users`}
							</p>
						</div>
						<IoMdClose
							size={20}
							onClick={handleClose}
							className="cursor-pointer"
							color="#A6A6A6"
						/>
					</div>
					<div className="py-6">
						{itemForm?.map((item, index) => (
							<Fragment key={index}>
								<NewInput
									onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
										handleInputChangeForMutipleItem(e, index, "category")
									}
									value={item.category}
									label={index === 0 ? "KPI Category" : ""}
									placeholder={"KPI dataset"}
								/>
								<div className="">
									<div>
										{index === 0 && (
											<label className="text-[#334155] font-medium text-sm inter">
												KPI data*
											</label>
										)}
										<div className="">
											{item?.dataArr?.length > 0 && (
												<div className="flex items-center gap-2 overflow-x-auto py-2 px-3">
													{item?.dataArr?.map((it, x) => (
														<span
															key={x}
															className="text-xs border border-black rounded-full px-3 py-1 flex items-center justify-between gap-3 w-auto whitespace-nowrap">
															{it}{" "}
															<FaTimes
																className="cursor-pointer"
																onClick={() => {
																	let newArr = item?.dataArr?.filter(
																		(j, k) => k !== x
																	);
																	let newItem = {
																		...item,
																		dataArr: newArr,
																	};
																	let newFinal = itemForm?.map((it, d) =>
																		d === index ? newItem : it
																	);
																	setItemForm(newFinal);
																	// setItemForm(prevRows => {
																	// 	const newRows = [...prevRows];
																	// 	newRows[index].dataArr?.splice(x, 1);
																	// 	return newRows;
																	// });
																}}
															/>
														</span>
													))}
												</div>
											)}
											<NewInput
												onKeyUp={(e: React.KeyboardEvent<HTMLInputElement>) =>
													handleInputKeyPress(e, index, "dataArr")
												}
												placeholder="Press Enter to input a new KPI data"
												onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
													handleInputChangeForMutipleItem(e, index, "data")
												}
												value={item.data}
												label={""}
											/>
										</div>
									</div>
								</div>
								<div className="">
									<TextBox
										placeholder="KPI Description"
										onChange3={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
											handleInputChangeForMutipleItem(e, index, "description")
										}
										value={item?.description}
										label={"KPI Description"}
									/>
								</div>
							</Fragment>
						))}
					</div>
					<div className="mt-4 flex justify-between items-center">
						<div className="flex gap-3 items-center"></div>
						<div className="flex gap-5">
							<MainBtn
								onClick={handleClose}
								className="border border-[#3787FF]"
								text={"Cancel"}
								bg={"transparent"}
								color={"#3787FF"}
							/>
							<MainBtn
								text={"Update"}
								bg={"#3787FF"}
								color={"white"}
								loading={loading}
								onClick={onSubmit}
							/>
						</div>
					</div>
				</div>
			</ModalContainer>
		</div>
	);
};
export default AddToolsModal;
